<script lang="ts" setup>
defineProps<{
  imgWidth: number
}>()
</script>

<template>
  <img src="/oneteam.png" alt="OneTeam" :width="imgWidth" />
</template>
